export default __webpack_public_path__ + "static/media/circleArrowDownSolid.c40994fb.svg";